import React from "react";
import { ToastContainer, cssTransition } from "react-toastify";
import AnimatedToastIcon from "./AnimatedToastIcon";
import "./toastTheme.css";

// The site's notifications: the same react-toastify calls as before (toast.success(...), toast.error(...)),
// shown as a small floating pill with a self-drawing icon. Click one to dismiss it.
const GlamTransition = cssTransition({
  enter: "glam-toast-in",
  exit: "glam-toast-out",
  collapse: true,
  collapseDuration: 220,
});

function GlamToastContainer() {
  return (
    <ToastContainer
      position="top-center"
      autoClose={3200}
      transition={GlamTransition}
      icon={AnimatedToastIcon}
      closeButton={false}
      hideProgressBar
      newestOnTop
      pauseOnHover
      pauseOnFocusLoss={false}
      closeOnClick
      draggable
      limit={3}
      className="glam-toast-container"
      toastClassName="glam-toast"
    />
  );
}

export default GlamToastContainer;
